import React, { useRef, useState } from 'react';
import './QuestionsPage.css';
import Footer from '../Footer';

import plusIcon from "./assets/svg/plus.svg";
import minusIcon from "./assets/svg/minus.svg";


const data = {
  'Topic 1': [
    { question: 'Kérdés lesz itt', answer: 'Válasz lesz itt.' },
    { question: 'Kérdés lesz itt', answer: 'Válasz lesz itt.' },
    { question: 'Kérdés lesz itt', answer: 'Válasz lesz itt.' },
  ],
  'Topic 2': [
    { question: 'Kérdés lesz itt', answer: 'Válasz lesz itt.' },
    { question: 'Kérdés lesz itt', answer: 'Válasz lesz itt.' },
  ],
  'Topic 3': [
    { question: 'Kérdés lesz itt', answer: 'Válasz lesz itt.' },
    { question: 'Kérdés lesz itt', answer: 'Válasz lesz itt.' },
  ],
  'Topic 4': [
    { question: 'Kérdés lesz itt', answer: 'Válasz lesz itt.' },
  ],
};

function FAQItem({ q, a }) {
  const [open, setOpen] = useState(false);
  const contentRef = useRef();

  const toggle = () => setOpen((prev) => !prev);

  return (
    <div className="faq-item">
      <button className="faq-question" onClick={toggle}>
        {q}
        <span className="icon">
          <img
            src={open ? minusIcon : plusIcon}
            alt=""
            className="icon-img"
          />
        </span>
      </button>

      <div
        ref={contentRef}
        className="faq-answer-wrapper"
        style={{
          height: open ? contentRef.current?.scrollHeight : 0,
        }}
      >
        <div className="faq-answer">
          {a}
        </div>
      </div>
    </div>
  );
}

function QuestionsPage() {
  const sections = useRef({});

  const scrollTo = (key) => {
    const el = sections.current[key];
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className="faq-page">
      <section className="faq-header">
        <div className="faq-container">
          <h1>Kérdések és válaszok</h1>
        </div>
      </section>

      <div className="faq-container faq-jump">
        <p className="jump-title">JUMP TO</p>
        <div className="jump-links">
          {Object.keys(data).map((key) => (
            <button key={key} onClick={() => scrollTo(key)}>
              {key}
            </button>
          ))}
        </div>
      </div>

      <section className="faq-content faq-container">
        {Object.entries(data).map(([topic, questions]) => (
          <div
            key={topic}
            className="faq-topic"
            ref={(el) => (sections.current[topic] = el)}
          >
            <h2>{topic}</h2>

            {questions.map((item, index) => (
              <FAQItem key={index} q={item.question} a={item.answer} />
            ))}
          </div>
        ))}
      </section>

      <Footer />
    </div>
  );
}

export default QuestionsPage;
